<template>
  <BModal
    id="main-guest-image-display-modal"
    v-model="isVisible"
    no-header
    no-footer
    :no-close-on-backdrop="true"
    @hidden="onModalHidden"
  >
    <BOverlay :show="overlayShow" rounded="sm">
      <div class="d-flex justify-content-end">
        <button type="button" class="btn-close" aria-label="Close" @click="hideModal()" />
      </div>
      <div class="text-start">
        <h5>スペック決定した商品の画像見積表示</h5>
      </div>
      <div class="p-0 row ms-5 mt-3" v-if="!overlayShow">
        <div
          v-for="i in 5"
          :key="i"
          class="col-12 row mt-2 align-items-center"
        >
          <div class="col-1"></div>
          <div :class="hasImage(i) ? 'col-9' : 'col-9 text-black-50'">
            {{ labels[i] }}
          </div>
          <div class="col-1 text-center">
            <BFormCheckbox
              v-if="hasImage(i)"
              v-model="localData['image'+i].display"
              switch
            />
          </div>
        </div>
        <div class="col-12 row mt-4">
          <div class="col-1"></div>
          <div class="col-10">×で閉じた後「見積を保存」を選択</div>
        </div>
      </div>
    </BOverlay>
  </BModal>
</template>
<script>
import { BModal, BOverlay, BFormCheckbox } from 'bootstrap-vue-next'

export default {
  name: 'MainGuestImageDisplayModal',
  components: { BModal, BOverlay, BFormCheckbox },
  props: {
    mainGuestImageDisplayData: {
      type: Object,
      required: true //  require → required
    }
  },
  emits: ['setMainGuestImageDisplayData'],
  data () {
    return {
      isVisible: false,
      overlayShow: false,
      localData: null,
      labels: {
        1: '１:中景',
        2: '２:メインテーブル',
        3: '３:ゲストテーブル(横長)',
        4: '４:ゲストテーブル(縦長)',
        5: '５:花合わせ'
      }
    }
  },
  methods: {
    showModal () {
      //  propを直接いじらないため、開くタイミングでローカルにコピー
      this.localData = structuredClone
        ? structuredClone(this.mainGuestImageDisplayData)
        : JSON.parse(JSON.stringify(this.mainGuestImageDisplayData))

      // hasImage=false のものは display も false に寄せる（念のため）
      for (let i = 1; i <= 5; i++) {
        const key = `image${i}`
        if (this.localData?.[key] && !this.localData[key].hasImage) {
          this.localData[key].display = false
        }
      }
      this.isVisible = true
    },
    hideModal () {
      this.isVisible = false
    },
    onModalHidden () {
      if (!this.localData) return
      this.$emit('setMainGuestImageDisplayData', this.localData)
    },
    hasImage (i) {
      const key = 'image' + i
      return !!(this.localData && this.localData[key] && this.localData[key].hasImage)
    }
  }
}
</script>
